import {
  LOAD_SHOP_DETAILS,
  SET_SHOP_DETAILS,
  UPDATING_SHOP,
  ENABLE_DISABLE_SHOP,
  DISPLAY_SHOP_SIDEBAR,
  LOAD_PUBLIC_STORE,
  SET_PUBLIC_STORE,
  SET_PUBLIC_STORE_PRODUCTS,
  LOAD_STORE_PRODUCT_DETAILS,
  SET_STORE_PRODUCT,
  SET_STORE_PRODUCT_VARIANTS,
  SET_STORE_VARIANTS_IMAGES,
  SET_STORE_VARIANT_DICTIONARY,
  SET_STORE_VARIANT_TYPES,
  SET_STORE_VARIANT_COLORS,
  SET_STORE_VARIANT_SIZES,
  PRODUCT_STORE_NOT_FOUND,
  UPDATE_STORE_VARIANT_SIZES,
  UPDATE_STORE_VARIANT_COLORS,
  LOAD_SUGGESTED_STORE_PRODUCTS,
  SET_SUGGESTED_STORE_PRODUCTS,
  LOAD_STORE_CART,
  SET_STORE_CART,
  IS_ADDING_ITEM_TO_CART,
  ADD_ITEM_TO_CART,
  SHOW_ADD_TO_CART_NOTIFICATION,
  HIDE_ADD_TO_CART_NOTIFICATION,
  IS_REMOVING_CART_ITEM,
  IS_UPDATING_CART_ITEM,
  IS_SETTING_SHIPPING_ADDRESS,
  ROLL_UP_SHIPPING_ADDRESS,
  ROLL_DOWN_FORM_BILLING_ADDRESS,
  SET_PAYMENT_DETAILS,
  CREATING_PAYMENT_INTENT,
  SET_PAYMENT_CLIENT_SECRET,
  CONNECTING_STRIPE,
  CREATING_STORE,
  SET_STRIPE_BLOB,
  SET_SHOP_STATS,
  SET_LOADING_SHOP_STAT,
  SET_LOADING_PAYOUTS,
  SET_SHOP_PAYOUTS,
  SET_EXPORTING_PAYOUT,
  SET_EXPORTING_ORDER,
  SET_STORE_PRODUCTS,
  SET_LOADING_PRODUCTS,
  SET_DNS_STATUS,
  SET_LOADING_CHECK_DNS,
  SET_SELECTED_PRODUCT_VARIANTS,
  SET_UPDATING_PRODUCT_VARIANTS,
  SET_PRODUCT_DEFAULT_IMAGE,
  SET_ECOM_PRODUCT_VARIANTS,
  FETCHING_GIFT_CARDS,
  SET_GIFT_CARDS,
  SET_GIFT_CARDS_TOTAL_COUNT,
  CREATING_GIFT_CARD,
  DELETING_GIFT_CARD,
  SELECT_ALL_GIFT_CARDS,
  SET_SELECTED_GIFT_CARDS,
  RESET_SELECTED_GIFT_CARDS
} from '@/state/mutationTypes'
import {
  SET_LOADING_ORDER,
  SET_LOADING_SHOP_ORDERS,
  SET_LOADING_PRODUCT_IMAGES,
  SET_CREATING_PRODUCT_IMAGES,
  SET_PRODUCT_ATTRIBUTES,
  RESET_PRODUCT_ATTRIBUTES,
  SET_ORDER,
  SET_SHOP_ORDERS,
  SET_SELECTED_IMAGE_ID
} from '../mutationTypes'

export default {
  [LOAD_SHOP_DETAILS](state, payload) {
    state.loadShopDetails = payload
  },
  [SET_SHOP_DETAILS](state, payload) {
    state.shopDetails = { ...payload }
  },
  [UPDATING_SHOP](state, payload) {
    state.updatingShop = payload
  },
  [CREATING_STORE](state, payload) {
    state.creatingStore = payload
  },
  [ENABLE_DISABLE_SHOP](state, payload) {
    state.enablingDisablingShop = payload
  },
  [DISPLAY_SHOP_SIDEBAR](state, payload) {
    state.openSideBar = payload
  },
  [LOAD_PUBLIC_STORE](state, payload) {
    state.loadPublicStore = payload
  },
  [SET_PUBLIC_STORE](state, payload) {
    state.publicStore = { ...payload }
  },
  [SET_PUBLIC_STORE_PRODUCTS](state, payload) {
    state.publicStoreProducts = payload
  },
  [LOAD_STORE_PRODUCT_DETAILS](state, payload) {
    state.loadStoreProductVariants = payload
  },
  [SET_STORE_PRODUCT](state, payload) {
    state.storeProduct = { ...payload }
  },
  [SET_STORE_PRODUCT_VARIANTS](state, payload) {
    state.storeProductVariants = payload
  },
  [SET_STORE_VARIANTS_IMAGES](state, payload) {
    let storeVariantsImages = []
    payload.map(productVariant => {
      if (productVariant.images.length) {
        storeVariantsImages = [...storeVariantsImages, ...productVariant.images]
      }
    })
    state.storeVariantImages = storeVariantsImages
  },
  [SET_STORE_VARIANT_DICTIONARY](state, payload) {
    let variantDictionary = payload.map(variant => {
      return {
        id: variant.id,
        type: variant.spec.type,
        color: variant.spec.color,
        colorCode: variant.colorCode,
        size: variant.spec.size
      }
    })

    state.storeVariantsDictionary = variantDictionary
  },
  [SET_STORE_VARIANT_COLORS](state) {
    let { storeVariantsDictionary } = state
    let variantColors = []
    storeVariantsDictionary.map(data => {
      let existColorAlready = variantColors.find(
        color => color.color === data.color
      )
      if (
        !existColorAlready &&
        data.color !== null &&
        data.color !== undefined
      ) {
        variantColors.push({
          id: data.id,
          colorCode: data.colorCode,
          color: data.color,
          disabled: state.storeVariantsTypes.length ? true : false
        })
      }
    })
    state.storeVariantsColors = variantColors
  },
  [SET_STORE_VARIANT_TYPES](state) {
    let { storeVariantsDictionary } = state
    let variantTypes = []
    storeVariantsDictionary.map(variant => {
      let existTypeAlready = variantTypes.find(
        type => type.type === variant.type
      )
      if (
        !existTypeAlready &&
        variant.type !== null &&
        variant.type !== undefined
      ) {
        variantTypes.push({
          id: variant.id,
          type: variant.type,
          disabled: true
        })
      }
    })
    state.storeVariantsTypes = variantTypes
  },
  [SET_STORE_VARIANT_SIZES](state) {
    let { storeVariantsDictionary } = state
    let variantSizes = []
    let sortSizesBy = process.env.VUE_APP_SORT_SIZES
      ? process.env.VUE_APP_SORT_SIZES.split(',')
      : []
    storeVariantsDictionary.map(data => {
      let existSizeAlready = variantSizes.find(size => size.size === data.size)
      if (!existSizeAlready && data.size !== null && data.size !== undefined) {
        variantSizes.push({
          size: data.size,
          disabled: state.storeVariantsColors.length ? true : false
        })
      }
    })

    // sort sizes to display based on env variable process.env.VUE_APP_SORT_SIZES if exist
    if (sortSizesBy.length) {
      let sizesToSort = variantSizes

      let notMatchedSizes = []
      sizesToSort.forEach(notMatch => {
        if (!sortSizesBy.includes(notMatch.size)) {
          notMatchedSizes.push(notMatch)
        }
      })

      variantSizes = []
      sortSizesBy.forEach(sizeSort => {
        let foundSizes = sizesToSort.filter(
          sizesMatch => sizesMatch.size === sizeSort
        )
        if (foundSizes) {
          variantSizes = [...variantSizes, ...foundSizes]
        }
      })

      variantSizes = [...variantSizes, ...notMatchedSizes]
    }

    state.storeVariantsSizes = variantSizes
  },
  [PRODUCT_STORE_NOT_FOUND](state, payload) {
    state.productStoreNotFound = payload
  },
  [UPDATE_STORE_VARIANT_SIZES](state, payload) {
    state.storeVariantsSizes = payload
  },
  [UPDATE_STORE_VARIANT_COLORS](state, payload) {
    state.storeVariantsColors = payload
  },
  [LOAD_STORE_CART](state, payload) {
    state.loadStoreCart = payload
  },
  [SET_STORE_CART](state, payload) {
    state.cartStore = { ...payload }
  },
  [IS_ADDING_ITEM_TO_CART](state, payload) {
    state.isAddingItemToCart = payload
  },
  [ADD_ITEM_TO_CART](state, payload) {
    let { cartStore } = state
    state.cartItems = [payload, ...cartStore]
  },
  [LOAD_SUGGESTED_STORE_PRODUCTS](state, payload) {
    state.loadingSuggestedProduct = payload
  },
  [SET_SUGGESTED_STORE_PRODUCTS](state, payload) {
    state.suggestedProducts = [...payload]
  },
  [SHOW_ADD_TO_CART_NOTIFICATION](state) {
    state.showAddedToCartNotification = true
  },
  [HIDE_ADD_TO_CART_NOTIFICATION](state) {
    state.showAddedToCartNotification = false
  },
  [IS_REMOVING_CART_ITEM](state, payload) {
    state.isRemovingItemFromCart = payload
  },
  [IS_UPDATING_CART_ITEM](state, payload) {
    state.isUpdatingItemFromCart = payload
  },
  [IS_SETTING_SHIPPING_ADDRESS](state, payload) {
    state.settingShippingAddress = payload
  },
  [ROLL_UP_SHIPPING_ADDRESS](state, payload) {
    state.shippingAddressFormRollUp = payload
  },
  [ROLL_DOWN_FORM_BILLING_ADDRESS](state, payload) {
    state.useDifferentBillingAddress = payload
  },
  [SET_PAYMENT_DETAILS](state, payload) {
    state.paymentDetails = { ...payload }
  },
  [CREATING_PAYMENT_INTENT](state, payload) {
    state.isCreatingPaymentIntent = payload
  },
  [CONNECTING_STRIPE](state, payload) {
    state.connectingStripe = payload
  },
  [SET_STRIPE_BLOB](state, payload) {
    const newShopDetails = { ...state.shopDetails }
    newShopDetails.stripeAccountBlob = payload
    state.shopDetails = newShopDetails
  },
  [SET_PAYMENT_CLIENT_SECRET](state, payload) {
    state.paymentIntent = { ...payload }
  },
  [SET_SHOP_STATS](state, payload) {
    state.shopStats = payload
  },
  [SET_LOADING_SHOP_STAT](state, payload) {
    state.loadingShopStats = payload
  },
  [SET_LOADING_SHOP_ORDERS](state, payload) {
    state.loadingOrders = payload
  },
  [SET_LOADING_PRODUCT_IMAGES](state, payload) {
    state.loadingProductImages = payload
  },
  [SET_CREATING_PRODUCT_IMAGES](state, payload) {
    state.creatingProductImages = payload
  },
  [SET_PRODUCT_ATTRIBUTES](state, payload) {
    state.productAttributes = payload
  },
  [RESET_PRODUCT_ATTRIBUTES](state, payload) {
    state.productAttributes = payload
  },
  [SET_SELECTED_IMAGE_ID](state, payload) {
    state.productAttributes.defaultECommerceImageId = payload
  },
  [SET_ECOM_PRODUCT_VARIANTS](state, payload) {
    state.productVariants = payload.data
  },
  [SET_SELECTED_PRODUCT_VARIANTS](state, payload) {
    const selectedProductVariants = state.selectedProductVariants
    if (payload == null) {
      state.selectedProductVariants = []
    } else {
      const variantIndex = selectedProductVariants.findIndex(
        ({ id }) => id === payload.id
      )
      if (variantIndex > -1) {
        selectedProductVariants[variantIndex].image_ids = payload.image_ids
      } else {
        selectedProductVariants.push(payload)
      }
      state.selectedProductVariants = selectedProductVariants
    }
  },
  [SET_UPDATING_PRODUCT_VARIANTS](state, payload) {
    state.updatingProductVariants = payload
  },

  [SET_SHOP_ORDERS](state, payload) {
    state.shopOrders = { ...state.shopOrders, ...payload }
  },
  [SET_LOADING_PAYOUTS](state, payload) {
    state.loadingShopPayouts = payload
  },
  [SET_SHOP_PAYOUTS](state, payload) {
    state.shopPayouts = payload
  },
  [SET_LOADING_ORDER](state, payload) {
    state.loadingOrder = payload
  },
  [SET_ORDER](state, payload) {
    state.orderDetails = payload
  },
  [SET_EXPORTING_PAYOUT](state, payload) {
    state.exportingPayout = payload
  },
  [SET_EXPORTING_ORDER](state, payload) {
    state.exportingOrder = payload
  },
  [SET_STORE_PRODUCTS](state, payload) {
    state.storeProducts = payload
  },
  [SET_PRODUCT_DEFAULT_IMAGE](state, payload) {
    const { product_id, defaultECommerceImageId, images } = payload
    const defaultECommerceImage = (images ? images : []).find(
      image => image.id === defaultECommerceImageId
    )
    let storeProducts = state.storeProducts
    let index = storeProducts.findIndex(product => product.id == product_id)
    storeProducts[index].defaultImageUrl = defaultECommerceImage
      ? defaultECommerceImage.url
      : null
    state.storeProducts = [...storeProducts]
  },

  [SET_LOADING_PRODUCTS](state, payload) {
    state.loadingProducts = payload
  },
  [SET_DNS_STATUS](state, payload) {
    state.dnsStatus = payload
  },
  [SET_LOADING_CHECK_DNS](state, payload) {
    state.loadingCheckDnsStatus = payload
  },
  [FETCHING_GIFT_CARDS](state, payload) {
    state.fetchingGiftCards = payload
  },
  [SET_GIFT_CARDS](state, payload) {
    state.giftCards = payload
  },
  [SET_GIFT_CARDS_TOTAL_COUNT](state, payload) {
    state.giftCardsTotalCount = payload
  },
  [CREATING_GIFT_CARD](state, payload) {
    state.creatingGiftCard = payload
  },
  [DELETING_GIFT_CARD](state, payload) {
    state.deletingGiftCards = payload
  },
  [SELECT_ALL_GIFT_CARDS](state) {
    state.selectAllGiftCards = !state.selectAllGiftCards
  },
  [RESET_SELECTED_GIFT_CARDS](state) {
    state.selectedGiftCards = []
  },
  [SET_SELECTED_GIFT_CARDS](state, payload) {
    let selectedGiftCards = [...state.selectedGiftCards]
    const isSelected = selectedGiftCards.includes(payload)
    if (isSelected) {
      selectedGiftCards = selectedGiftCards.filter(id => id !== payload)
    } else {
      selectedGiftCards.push(payload)
    }

    state.selectedGiftCards = [...selectedGiftCards]
  }
}
